import store from "../../state/store";
import { CallEmsApi, iEmsApiResponseBody } from "../../Logic/EmsAPI/FetchExtension";
import { alarmsDTO } from "../UserAlarms/tenantApiCalls";

export interface notificationDTO {
    notificationID: number;
    notificationTypeID?: number;
    data?: string;
}

export interface GetUserNotificationsResponse {
    alarms: alarmsDTO[];
    notifications: notificationDTO[];
}

export async function GetUserNotificationsData(): Promise<iEmsApiResponseBody<GetUserNotificationsResponse>> {
    let user = store.getState().UserInformation;
    return await CallEmsApi<GetUserNotificationsResponse>("GET", `Notifications/User/${user.userID}`);
}

export async function DismissNotifications(notificationIds: number[]): Promise<iEmsApiResponseBody<void>> {
    let user = store.getState().UserInformation;
    return await CallEmsApi<void>("POST", `Notifications/User/${user.userID}/Dismiss`, notificationIds);
}
